// @flow
import { selectClientSupportsAAC, selectClientSupportsMP3 } from './playbackSupport';
import { m3u8Resolver, mp3Resolver } from '../lib/players/utils/trackUrlResolver';
import type { AudioQuality } from '../actions/client';
import { AUDIO_QUALITY_LOSSLESS } from '../constants';

export function selectTrackUrl(state: Object, compoundId: string) {
  return state.maps.trackUrls[compoundId];
}

export function selectDefaultTrackUrlResolver(state: Object): Function {
  if (selectClientSupportsMP3(state)) {
    return mp3Resolver;
  }

  if (selectClientSupportsAAC()) {
    return m3u8Resolver;
  }

  return (url: string) => url;
}

export function selectSonosTrackUrlResolver(quality: AudioQuality): Function {
  return quality === AUDIO_QUALITY_LOSSLESS ? mp3Resolver : m3u8Resolver;
}
